import $ from 'jquery';
import attachEnterAsClick from 'utils/attachEnterAsClick';

const sitemapInit = () => {
    const $sitemap = $('.s-sitemap-kentico ul');
    const openClass = 'is-open';
    const iconClass = '.svg-icon';

    if ($sitemap.length === 0) {
        return;
    }

    $sitemap.find('li ul').closest('li')
        .prepend($('.s-sitemap-kentico-icon-source svg').clone().attr('tabindex', '0'))
        .find('ul')
        .slideUp();

    $sitemap.find(iconClass).click(function () {
        const $el = $(this);
        const $li = $el.closest('li');

        if ($li.hasClass(openClass)) {
            $li.removeClass(openClass)
                .find('> ul').slideUp();
        } else {
            $li.addClass(openClass)
                .find('> ul').slideDown();
        }
    });
    attachEnterAsClick($sitemap.find(iconClass));
};

// doc ready
$(() => {
    sitemapInit();
});
